import React from 'react';
import { Check } from 'lucide-react';

const ALL_STEPS = [
  { id: 1, label: 'Account' },
  { id: 2, label: 'Payment' },
  { id: 3, label: 'Details' },
  { id: 4, label: 'Login' },
  { id: 5, label: 'Alerts' },
];

// Freelancer path skips Payment and Alerts.
const FREELANCER_SKIP = new Set([2, 5]);

/**
 * Checklist-style stepper for the signup wizard.
 */
export default function ProgressBar({ step, isFreelancer }) {
  const steps = ALL_STEPS.filter((s) => !(isFreelancer && FREELANCER_SKIP.has(s.id)));

  return (
    <div className="px-6 pt-6">
      <div className="flex items-center justify-between">
        {steps.map((s, idx) => {
          const isDone = step > s.id;
          const isCurrent = step === s.id;
          const displayNum = idx + 1;
          return (
            <React.Fragment key={s.id}>
              <div className="flex flex-col items-center gap-1.5 flex-shrink-0">
                <div
                  className={`w-9 h-9 rounded-full flex items-center justify-center text-sm font-semibold transition-all duration-300 ${
                    isDone
                      ? 'bg-indigo-600 text-white'
                      : isCurrent
                        ? 'bg-slate-900 text-white ring-4 ring-slate-900/10'
                        : 'bg-slate-100 text-slate-400 border border-slate-200'
                  }`}
                  data-testid={`signup-step-${s.id}`}
                >
                  {isDone ? <Check className="w-4 h-4" /> : displayNum}
                </div>
                <span className={`text-[10px] font-medium tracking-wide hidden sm:block ${
                  isCurrent ? 'text-slate-900' : 'text-slate-400'
                }`}>
                  {s.label}
                </span>
              </div>
              {idx < steps.length - 1 && (
                <div className="flex-1 h-0.5 mx-1.5 -mt-4 rounded-full overflow-hidden bg-slate-200">
                  <div
                    className={`h-full bg-indigo-600 transition-all duration-500 ${isDone ? 'w-full' : 'w-0'}`}
                  />
                </div>
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
}
